import { CommonModule, JsonPipe } from '@angular/common';
import { Component, inject, model, signal } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { DialogGenericComponent } from '../dialog-generic/dialog-generic.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormElementsComponent } from '../form-elements/form-elements.component';

@Component({
  selector: 'app-togliere',
  imports: [JsonPipe, FormsModule, ReactiveFormsModule, CommonModule, MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule,
    MatButtonToggleModule,
    FormElementsComponent
  ],
  templateUrl: './togliere.component.html',
  styleUrl: './togliere.component.css'
})
export class TogliereComponent {

  form: FormGroup;
  formElements: Array<{
    type: string;
    name?: string;
    label: string;
    options?: string[];
    children?: Array<{ type: string; name?: string; label: string; options?: string[]; children?: any }>
  }> = [];
  selectedElementType: string = 'input';
  labelText: string = '';
  insertIndex: number | null = null;
  private elementCounter: number = 0;

  constructor(private fb: FormBuilder) {

    this.form = this.fb.group({});
    this.form = this.fb.group({
      elements: this.fb.array([])
    });
    /*this.addElement("header", "AAAAAAAAAAAAA", NaN);
    this.addElement("input", "INPUT 1", NaN);
    this.addElement("IntestazioneSezione", "BBBBBBBBBBB", NaN);
    this.addElement("input", "INPUT 3", NaN);
    this.addElement("input", "INTPUT 4", NaN);*/
    console.log(this.form);
    console.log(this.formElements);
  }

  addElement(typeP: any, labelP: any, indexP: any): void {
    const fieldName = typeP !== 'IntestazioneSezione' && typeP !== 'header' && typeP !== 'section' ? `field${this.elementCounter++}` : undefined;

    const newElement = {
      type: typeP,
      name: fieldName,
      label: labelP,
      //children: typeP === 'section' || typeP === 'subSection' ? [] : undefined
      children: []
    };



    if (fieldName) {
      //this.form.addControl(fieldName, new FormControl(''));
      const elements = this.form.get('elements') as FormArray;
      elements.push(this.fb.control(fieldName));
      elements.push(this.fb.control("aaaaaaaaaa"));
      
    }

    if (indexP !== null && indexP >= 0 && indexP < this.formElements.length) {
      this.formElements.splice(indexP, 0, newElement);
    } else {
      this.formElements.push(newElement);
    }


    console.log(this.form);
  }

  readonly animal = signal('');
  readonly name = model('');
  readonly dialog = inject(MatDialog);

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogGenericComponent, {
      data: { name: this.name(), animal: this.animal() },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result !== undefined) {
        console.log(result);
        this.selectedElementType = result.selectedElementType;
        this.insertIndex = result.insertIndex;
        this.labelText = result.labelText;
        this.addElement(result.selectedElementType, result.labelText, result.insertIndex);
      }
    });
  }

  cambiaPos(i: number, scostamento: number) {

    const newIndex = i + scostamento;

    // Ensure the new index is within bounds
    if (newIndex < 0 || newIndex >= this.formElements.length) {
      console.warn('Invalid move: Out of bounds.');

    } else {
      [this.formElements[i], this.formElements[newIndex]] = [this.formElements[newIndex], this.formElements[i]];
      console.log(this.formElements);
    }

  }

  stampa(){
    console.log(this.formElements);
  }


}
